import axios from "axios";
import Vue from "vue";

const axiosService = axios.create();

// const userAuthService = new UserAuthService();

axiosService.interceptors.request.use(
  config => {
    const authHeader = Vue.prototype.$dataService.actions.Auth.getAuthHeader();

    if (authHeader) {
      config.headers["Authorization"] = authHeader.Authorization;
    }

    config.headers["Access-Control-Allow-Origin"] = "*";

    return config;
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

export default axiosService;
